









import Vue from 'vue'
import ComputerStats from '@/components/ComputerStats'
import { UserNetworkStats } from '@/types/networkstats'
import { KeyDict } from '@/types'
import { InvitedCaster } from '@/types/casts'

export default Vue.extend({
  name: 'ComputerStatsContainer',
  computed: {
    userId (): string {
      return this.$store.direct.state.user.id
    },
    stats (): UserNetworkStats {
      return this.userId && (this.$store.direct.getters.networkStats.userStats as Function)(this.userId)
    },
    invitedCasters (): KeyDict<InvitedCaster>  {
      return this.$store.direct.getters.events.invitedCasters
    },
    isCasting (): boolean  {
      return this.$store.direct.state.events.casting
    },
    userIsCaster (): boolean {
      return this.invitedCasters.hasOwnProperty(this.userId)
    }
  },
  components: {
    ComputerStats
  }
})
